import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Grid, Typography, Button as MUIButton } from '@material-ui/core';

import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { formatDocument, formatPhone, formatPostalCode } from 'helpers/formatters';

function RegisterFields({ register }) {
  const changedKeys = Object.keys(register || {});
  const address = register?.addresses?.[0] || {};
  const addressKeys = Object.keys(address);

  return(
    <>
      {changedKeys.includes('establishmentName') && (
        <Row>
          <Typography color='primary'>Nome do estabelecimento</Typography>
          <Typography color='textSecondary'>{register?.establishmentName || '--'}</Typography>
        </Row>
      )}
      {changedKeys.includes('documentId') && (
        <Row>
          <Typography color='primary'>CNPJ</Typography>
          <Typography color='textSecondary'>{formatDocument(register?.documentId) || '--'}</Typography>
        </Row>
      )}
      {changedKeys.includes('phone') && (
        <Row>
          <Typography color='primary'>Telefone</Typography>
          <Typography color='textSecondary'>{formatPhone(register?.phone) || '--'}</Typography>
        </Row>
      )}
      {changedKeys.includes('email') && (
        <Row>
          <Typography color='primary'>Email</Typography>
          <Typography color='textSecondary'>{register?.email || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('postalCode') && (
        <Row>
          <Typography color='primary'>CEP</Typography>
          <Typography color='textSecondary'>{formatPostalCode(address?.postalCode) || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('street') && (
        <Row>
          <Typography color='primary'>Endereço</Typography>
          <Typography color='textSecondary'>{address?.street || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('number') && (
        <Row>
          <Typography color='primary'>Número</Typography>
          <Typography color='textSecondary'>{address?.number ?? '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('complement') && (
        <Row>
          <Typography color='primary'>Complemento</Typography>
          <Typography color='textSecondary'>{address?.complement || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('district') && (
        <Row>
          <Typography color='primary'>Bairro</Typography>
          <Typography color='textSecondary'>{address?.district || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('city') && (
        <Row>
          <Typography color='primary'>Cidade</Typography>
          <Typography color='textSecondary'>{address?.city || '--'}</Typography>
        </Row>
      )}
      {addressKeys.includes('state') && (
        <Row>
          <Typography color='primary'>UF</Typography>
          <Typography color='textSecondary'>{address?.state || '--'}</Typography>
        </Row>
      )}
      {changedKeys.includes('vacanciesMarks') && (
        <Row>
          <Typography color='primary'>Total de ocupação do pátio</Typography>
          <Typography color='textSecondary'>{register?.vacanciesMarks ?? '--'}</Typography>
        </Row>
      )}
    </>
  );
}

RegisterFields.propTypes = {
  register: PropTypes.object
};

export default function Update({ activityData, lastRegister, newRegister }) {
  const IS_CURRENT = 'current';
  const IS_PREVIOUS = 'previous';

  const [selectedConfig, setSelectedConfig] = useState(IS_CURRENT);

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 20 }}>
          <Grid md={6} style={{ backgroundColor: (selectedConfig == IS_CURRENT) ? 'rgba(44, 169, 214, 0.24)' : '#E4E7EA', borderBottom: (selectedConfig == IS_CURRENT) ? '2px solid #022A5C' : '' }}>
            <MUIButton
              style={{ width: '100%', textTransform: 'capitalize', padding: 15 }}
              onClick={() => setSelectedConfig(IS_CURRENT)}
            >
              {(selectedConfig == IS_CURRENT) ? (
                <Typography color='primary'>
                  <b>Configuração Atual</b>
                </Typography>
              ) : (
                <Typography color='textSecondary'>Configuração Atual</Typography>
              )}
            </MUIButton>
          </Grid>
          <Grid md={6} style={{ backgroundColor: (selectedConfig == IS_PREVIOUS) ? 'rgba(44, 169, 214, 0.24)' : '#E4E7EA', borderBottom: (selectedConfig == IS_PREVIOUS) ? '2px solid #022A5C' : '' }}>
            <MUIButton
              style={{ width: '100%', textTransform: 'capitalize', padding: 15 }}
              onClick={() => setSelectedConfig(IS_PREVIOUS)}
            >
              {(selectedConfig == IS_PREVIOUS) ? (
                <Typography color='primary'>
                  <b>Configuração Anterior</b>
                </Typography>
              ) : (
                <Typography color='textSecondary'>Configuração Anterior</Typography>
              )}
            </MUIButton>
          </Grid>
        </Grid>
        <Grid container>
          {(selectedConfig == IS_CURRENT) && (
            <Grid xs={12}>
              <Grid style={{ backgroundColor: '#FCFCFC', border: '1px solid #E4E7EA', padding: 8 }}>
                <RegisterFields register={newRegister} />
              </Grid>
            </Grid>
          )}
          {(selectedConfig == IS_PREVIOUS) && (
            <Grid xs={12}>
              <Grid style={{ backgroundColor: '#FCFCFC', border: '1px solid #E4E7EA', padding: 8 }}>
                <RegisterFields register={lastRegister} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

Update.propTypes = {
  activityData: PropTypes.object.isRequired,
  lastRegister: PropTypes.object,
  newRegister: PropTypes.object
};